export default "__VITE_ASSET__qzy7fQ4s__"